import classNames from 'classnames';

import type { SamvalgsverktoyDto } from '../../types/cms';

import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import Title from '@helsenorge/designsystem-react/components/Title';

import PortableText from '@helsenorge/core-cms/richtext';
import type { FasteTeksterDto } from '@helsenorge/core-cms/types/entities/cms.v1entities';
import { formatCET, DateFormat } from '@helsenorge/core-utils/date-fns-utils';

import styles from './styles.module.scss';

interface Props {
  sistFagligOppdatert: Date;
  nesteFagligOppdatering: Date;
  innholdLevertAv: SamvalgsverktoyDto['innholdLevertAv'];
  utvikletAv: SamvalgsverktoyDto['utvikletAv'];
  finansiertAv: SamvalgsverktoyDto['finansiertAv'];
  bidragsyterOgInteresser: SamvalgsverktoyDto['bidragsyterOgInteresser'];
  fasteTekster: FasteTeksterDto;
}

const CreditsBlock: React.FC<Props> = ({
  sistFagligOppdatert,
  nesteFagligOppdatering,
  innholdLevertAv,
  utvikletAv,
  finansiertAv,
  bidragsyterOgInteresser,
  fasteTekster,
}: Props) => {
  if (
    fasteTekster &&
    (sistFagligOppdatert || nesteFagligOppdatering || innholdLevertAv || utvikletAv || finansiertAv || bidragsyterOgInteresser)
  ) {
    const sistFagligOppdatertFormat = formatCET(sistFagligOppdatert, DateFormat.ShortDate);
    const nesteFagligOppdateringFormat = formatCET(nesteFagligOppdatering, DateFormat.ShortDate);

    const mainColumnClass = 'col-12 col-md-6 col-lg-6';

    return (
      <>
        <div className={styles['credits-linje']} />
        <div className={classNames('col-md-10 offset-md-1 col-lg-8 offset-lg-2', styles['credits-wrapper'])}>
          <div className={'row'}>
            {sistFagligOppdatertFormat && sistFagligOppdatertFormat !== 'Invalid Date' && (
              <div className={mainColumnClass}>
                <Spacer size={'l'} />
                <Title htmlMarkup="h2" appearance="title4">
                  {fasteTekster.lastUpdate}
                </Title>
                <Spacer size={'4xs'} />
                <p>{sistFagligOppdatertFormat}</p>
              </div>
            )}
            {nesteFagligOppdateringFormat && nesteFagligOppdateringFormat !== 'Invalid Date' && (
              <div className={mainColumnClass}>
                <Spacer size={'l'} />
                <Title htmlMarkup="h2" appearance="title4">
                  {fasteTekster.nextUpdate}
                </Title>
                <Spacer size={'4xs'} />
                <p>{nesteFagligOppdateringFormat}</p>
              </div>
            )}
            {innholdLevertAv && innholdLevertAv.length > 0 && (
              <div className={mainColumnClass}>
                <Spacer size={'l'} />
                <Title htmlMarkup="h2" appearance="title4">
                  {fasteTekster.contentProvidedBy}
                </Title>
                <Spacer size={'4xs'} />
                {innholdLevertAv.map((levertAvContent, index) => {
                  return <PortableText key={index} value={levertAvContent} />;
                })}
              </div>
            )}
            {utvikletAv && utvikletAv.length > 0 && (
              <div className={mainColumnClass}>
                <Spacer size={'l'} />
                <Title htmlMarkup="h2" appearance="title4">
                  {fasteTekster.developedBy}
                </Title>
                <Spacer size={'4xs'} />
                {utvikletAv.map((utvikletAvContent, index) => {
                  return <PortableText key={index} value={utvikletAvContent} />;
                })}
              </div>
            )}
            {finansiertAv && finansiertAv.length > 0 && (
              <div className={mainColumnClass}>
                <Spacer size={'l'} />
                <Title htmlMarkup="h2" appearance="title4">
                  {fasteTekster.financedBy}
                </Title>
                <Spacer size={'4xs'} />
                {finansiertAv.map((finansiertAvContent, index) => {
                  return <PortableText key={index} value={finansiertAvContent} />;
                })}
              </div>
            )}
            {bidragsyterOgInteresser && bidragsyterOgInteresser.length > 0 && (
              <div className={mainColumnClass}>
                <Spacer size={'l'} />
                <Title htmlMarkup="h2" appearance="title4">
                  {fasteTekster.contributorsAndInterests}
                </Title>
                <Spacer size={'4xs'} />
                {bidragsyterOgInteresser.map((bidragsystereContent, index) => {
                  return <PortableText key={index} value={bidragsystereContent} />;
                })}
              </div>
            )}
          </div>
        </div>
        <Spacer size={'l'} />
      </>
    );
  } else {
    return null;
  }
};

export default CreditsBlock;
